var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"centered vue-loader",staticStyle:{"height":"calc(100vh - 150px)"}},[_c('vue-loader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }